module.exports = __webpack_public_path__ + "img/home-ic.98bcd637.svg";